module.exports = __webpack_public_path__ + "static/introvid-24e3f03f49abc20d91c803136f9520dd.webm";